/*

Suresh Peddavoora 10/26/2022 3075154998  Added Class Name for Table Enhancements
Ashraf 10/30/2022 3075154998 fixed table pagination issue
saikrishna 11/03/2022 3075154998 changed the paginationOptions

*/
import React, {createRef, useState} from 'react';
// import MaterialTable from "material-table";
import {tableIcons} from '../../../../../../components/TableIcons';
import DeleteTableRecordPopup from '../../../../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import {TablePagination} from '@material-ui/core';
import {defaultRows} from '../../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../../constants/ReusableConstants';

export default function ActionTable({
  actionData,
  setActionData,
  setActionRowData,
  setIsEditMode,
  setActionCode,
  deleteAction,
  setDeleteAction,
}) {
  const [rows, setRows] = useState(defaultRows);
  const columns = [
    {
      title: 'Seq No',
      field: 'seqNo',
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        maxWidth: 200,
        textAlign: 'center',
      },
      render: (rowData) => {
        const rowSeqNo = rowData?.tableData?.id ?
          rowData?.tableData?.id + 1 :
          rowData?.tableData?.id === 0 ?
            1 :
            '';
        actionData[rowData.tableData.id].seqNo = rowSeqNo;
        return rowSeqNo;
      },
    },
    {
      title: 'Description',
      field: 'description',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
    },
    {
      title: 'Position',
      field: 'position',
    },
    {
      title: 'Field',
      field: 'field',
    },
    {
      title: 'Type',
      field: 'type',
    },
    {
      title: 'Format Spec',
      field: 'format',
    },
    {
      title: 'Group',
      field: 'group',
    },
  ];

  const tableRef = createRef();
  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const tableDataAction = actionData ?
    actionData?.map((item, i) => ({
      ...item,
      id: i,
    })) :
    [];

  const handleActionEdit = (rowData) => {
    setIsEditMode(true);
    setActionRowData(rowData);
  };
  const handleDelete = (rowData) => {
    setIsDelete(true);
    setDeleteData(rowData);
  };
  const handleClose = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    setTimeout(() => {
      const data = [...actionData];
      const newData = data.filter((row, i) => row.sequenceNo !== deleteData.sequenceNo);
      const newDeletedIds = [...deleteAction];
      if (deleteData?.actionId) {
        newDeletedIds.push(deleteData?.actionId);
      }
      setDeleteAction(newDeletedIds);
      setActionData(newData);
    }, 1000);
    setIsDelete(false);
  };
  return (
    <div>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Action"
        value={`Are you sure you want to delete this action?`}
        handleSubmit={handleSubmit}
      />
      <div className="custom-table global-field-table">
        <GuiTable
          title=""
          columns={columns}
          icons={tableIcons}
          tableRef={tableRef}
          data={tableDataAction}
          options={{
            search: false,
            toolbar: false,
            pageSize: rows,
            showSelectAllCheckbox: false,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          components={{
            Pagination: (props) => (
              <TablePagination
                {...props}
                SelectProps={{
                  inputProps: {'aria-label': 'Rows per screen'},
                }}
                labelRowsPerPage={'Rows per screen:'}
                rowsPerPageOptions={tablePageRows}
                onChangeRowsPerPage={(event) => {
                  props.onChangeRowsPerPage(event);
                  setRows(event.target.value);
                }}
              />
            )}}
          actions={[
            {
              icon: 'edit',
              tooltip: 'Edit',
              onClick: (event, rowData) => {
                handleActionEdit(rowData);
                setActionCode(rowData.id);
              },
            },
            {
              icon: 'delete',
              tooltip: 'Delete',
              onClick: (event, rowData) => {
                handleDelete(rowData);
                setIsDelete(true);
              },
            },
          ]}
        />
      </div>
    </div>
  );
}
